import React, { Component, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

//Import Icons
import FeatherIcon from 'feather-icons-react';

import logoLight from '../../../assets/images/watopa/watopa-light.png';

//Import Switcher
import BackToTop from '../../../components/Layout/backToTop';

const Loader = () => {
  return (
    <div id="preloader">
      <div id="status">
        <div className="spinner">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
      </div>
    </div>
  );
};

class Footer2 extends Component {
  render() {
    return (
      <React.Fragment>
        <Suspense fallback={Loader()}>
          <footer className="footer" id="copyright">
            <Container>
              <Row className="justify-content-center">
                <Col className="col-12">
                  <div className="footer-py-60 text-center">
                    <Row className="justify-content-center">
                      <Col
                        lg={6}
                        col={12}
                        className="mb-0 mb-md-4 pb-0 pb-md-2"
                      >
                        <Link to="#" className="logo-footer">
                          <img src={logoLight} height="40" alt="" />
                        </Link>
                        <p className="mt-4">
                          Innovación y Eficiencia A tu Alcance.
                        </p>
                        <ul className="list-unstyled social-icon foot-social-icon mb-0 mt-4">
                          <li className="list-inline-item">
                            <Link to="#" className="rounded">
                              <FeatherIcon
                                icon="facebook"
                                className="fea icon-sm fea-social"
                              />
                            </Link>
                          </li>{' '}
                          <li className="list-inline-item">
                            <Link to="#" className="rounded">
                              <FeatherIcon
                                icon="instagram"
                                className="fea icon-sm fea-social"
                              />
                            </Link>
                          </li>{' '}
                          <li className="list-inline-item">
                            <Link to="#" className="rounded">
                              <FeatherIcon
                                icon="twitter"
                                className="fea icon-sm fea-social"
                              />
                            </Link>
                          </li>{' '}
                          <li className="list-inline-item">
                            <Link to="#" className="rounded">
                              <FeatherIcon
                                icon="linkedin"
                                className="fea icon-sm fea-social"
                              />
                            </Link>
                          </li>{' '}
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>

            <Container>
              <Row>
                <Col className="col-12">
                  <div className="footer-py-30 footer-border">
                    <Container className="text-center">
                      <Row className="align-items-center">
                        <Col sm={12}>
                          <div className="text-sm-center">
                            <p className="mb-0">
                              © {new Date().getFullYear()} Watopa.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Col>
              </Row>
            </Container>
          </footer>

          <BackToTop />
        </Suspense>
      </React.Fragment>
    );
  }
}

export default Footer2;
